import { FirebaseContext } from '../../../context/firebase';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import * as STORAGE_BUCKET from '../../../constants/storageBucket';
import * as PROJECT_CODE from '../../../constants/projectCode';

export async function GetFloorPlanImageInformation(){
    const { firebase } = useContext(FirebaseContext);

    var returnValue;
    await firebase.database().ref("/kavtek_clients/" + PROJECT_CODE.projectCode + "/unityUI").once('value').then((snapshot) =>{
        returnValue = snapshot.val();
    })

    return returnValue;
}